import { Injectable, Optional, Inject } from '@angular/core';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS, MatMomentDateAdapterOptions } from '@angular/material-moment-adapter';
import * as moment from 'moment';
import { Moment } from 'moment';
import { MAT_DATE_LOCALE } from '@angular/material/core';

@Injectable()
export class ThaiMomentDateAdapter extends MomentDateAdapter {

  constructor(
      @Optional() @Inject(MAT_DATE_LOCALE) dateLocale: string,
      @Optional() @Inject(MAT_MOMENT_DATE_ADAPTER_OPTIONS)
      private options?: MatMomentDateAdapterOptions) {

    super(dateLocale, options);
    this.setLocale(dateLocale || moment.locale());
  }

  createDate(year: number, month: number, date: number): moment.Moment {
    if (year > 2500) {
      year = year - 543;
    }
    return super.createDate(year, month, date);
  }

  parse(value: any, parseFormat: string | string[]): moment.Moment {
    const m = super.parse(value, parseFormat);
    if (m.year() > 2500) {
      return m.subtract({years: 543});
    }
    return m;
  }

  getYearName(date: Moment): string {
    return this.clone(date).add({ years: 543 }).format('YYYY');
  }

  format(date: Moment, displayFormat: string): string {
    date = this.clone(date);
    if (!this.isValid(date)) {
      throw Error('MomentDateAdapter: Cannot format invalid date.');
    }
    return date.add({ years: 543 }).format(displayFormat);
  }
}
